export const TRACKING_EVENT_TYPE = {
  'assets': 'HOLDINGS_ASSET_VIEWED',
  'packs': 'HOLDINGS_PACKS_VIEWED',
  'watchlist': 'HOLDINGS_WATCHLIST_VIEWED',
};
